import { Injectable } from '@angular/core';
import { SortOrder } from '../../../shared/tables/datatable/datatable.models';
import { MigrationStatusV2 } from '../../../shared/models/generated/ziroModels';
import { SiteProgressBucket } from '../../services/migrations-site-progress.service';

export enum SiteBarMode {
  FULL_WIDTH = 'FULL_WIDTH',
  PROPORTIONAL = 'PROPORTIONAL',
}

export interface SitesOverviewState {
  bucketFilter: SiteProgressBucket;
  statusFilter: MigrationStatusV2;
  barMode: SiteBarMode;
  sortColumn: string;
  sortOrder: SortOrder;
}

@Injectable({ providedIn: 'root' })
export class MigrationsSitesOverviewStateService {
  private _stateByAssessmentId: Map<string, SitesOverviewState> = new Map();

  getState(assessmentId: string): SitesOverviewState {
    const defaultState: SitesOverviewState = {
      bucketFilter: null,
      statusFilter: null,
      barMode: SiteBarMode.FULL_WIDTH,
      sortColumn: '',
      sortOrder: null,
    };

    return this._stateByAssessmentId.has(assessmentId)
      ? { ...defaultState, ...this._stateByAssessmentId.get(assessmentId) }
      : defaultState;
  }

  patchState(assessmentId: string, changes: Partial<SitesOverviewState>): void {
    this._stateByAssessmentId.set(assessmentId, { ...this.getState(assessmentId), ...changes });
  }
}
